<template>
    <div class="product-wrap d-flex flex-column mb-4" :data-id="product.ID" v-if="show">
        <div class="product-data d-flex">
            <div class="product-img-wrap">
                <div class="product-img" :style="{ 'background-image': `url(${product.product_image})` }" ><a :href="product.permalink" target="_blank"></a></div>                
            </div>
            <div class="product-text pl-4">
                <h2 class="mb-2"><a :href="product.permalink" target="_blank">{{  product.post_title }}</a></h2>
                <ul class="d-flex product-description ml-0">
                    <li><strong>{{ product.kcals }}</strong> Kcals</li>
                    <li><strong>{{ product.protein }}gr</strong> Protein</li>
                    <li><strong>{{ product.carbs }}gr</strong> Carbs</li>
                    <li><strong>{{ (product.price/100).toFixed(2) }}</strong> Price</li>
                </ul>
                <div class="product-control-row d-flex align-center mt-3 mb-3">
                    <div class="d-flex align-center btn-change-row">
                        <v-btn 
                        class="btn-product btn-product-change"
                        height='50'
                        width='120'
                        rounded="10"
                        border="2"
                        @click="replaceProduct(product)"            
                        >Select</v-btn>
                    </div>
                </div>  
            </div>
        </div>     
    </div>
</template>

<script>

export default {
    name: 'productPopup',
    components: {        
    },
    props: ['product'],
    data() {
        return {
            show: true,
            menus: [],            
        }
    },
    computed: {        
        itemsOrder() {
            return this.$store.getters.itemsOrder;
        },
        orderProducts() {
            return this.$store.getters.orderProducts;
        },
        popupProduct() {
            return this.$store.getters.popupProduct;
        },  
 
    },
    methods: {
        replaceProduct(addProduct) {
           
            addProduct.count = Number(this.popupProduct.count);        
            
            if ( this.popupProduct.category == 'main' ) { 
        
                    let data = [...this.orderProducts.mainProducts];

                    data = data.map((product) => {
                    
                        if (product.ID === this.popupProduct.oldproductID) {
                        
                            return addProduct;
                        } else {
                            return product;
                        }
                    });
                
                    this.orderProducts.mainProducts = [...data];
            }

            if (this.popupProduct.category == 'breakfast') {

                let data = [...this.orderProducts.breakfastProducts];

                data = data.map((product) => {
                    if (product.ID === this.popupProduct.oldproductID) {
                        return addProduct;
                    } else {
                        return product;
                    }
                });

                this.orderProducts.breakfastProducts = [...data];
            }
           
            if (this.popupProduct.category == 'snacks') {
                
                let data = [...this.orderProducts.snacksProducts];

                data = data.map((product) => {
                    if (product.ID === this.popupProduct.oldproductID) {
                        return addProduct;
                    } else {
                        return product;
                    }
                });

                this.orderProducts.snacksProducts = [...data];
          
            }

            this.$emit('update:visible', false);
        },

    },
    emits: ['update:visible'],
    async beforeMount() {
    }  

}
</script>

<style lang="stylus">
    .btn-change-row {
        gap: .5rem;
        
        @media (max-width: 380px) {
            gap: .2rem;
            max-width: calc(100% - .2rem - 155px);
        }
        .v-btn {
            @media (max-width: 480px) {
                max-width: 48%;
            }
        }
    }

    .btn-product {
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #1D2433;
        text-transform: capitalize;
        letter-spacing: normal;
        border-radius: 10px;

        &-change {
            box-shadow: none;
            border: 2px solid #E1E6EF;
            
            &.v-btn--disabled {
                opacity: .7!important;  
                cursor: no-drop!important;
                pointer-events: auto;   
            }
        }

        &-delete {
            background: none;
            @media (max-width: 400px) {
                padding: 0;
            }
        }
    }
</style>
<style scoped lang="stylus">
.product-data {
    @media screen and (max-width: 389px) {
        flex-direction: column!important;
    }
    .product-text {
        @media screen and (max-width: 389px) {
            padding-top: 1rem;
            padding-left: 0!important;
            max-width: 100%!important;
            padding-bottom: 0.5rem;
        }
    }
}
   .product-wrap {
        border-bottom: 2px solid #e1e6ef;
        .product-control-row {
            border-bottom: none!important;
        }
        &:last-child .product-control-row {
            margin-bottom: 0!important;
            padding-bottom: .5rem!important;

        }
    }
    .product-control
        display: grid;
        gap: .5rem;
        width: 185px;

        @media (max-width: 480px) {
            gap: .2em;
            width: 155px;
        }
       
        &-row {
            border-bottom: 2px solid #E1E6EF;
        }

        & > div
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-radius: 10px;
                width: 45px;
                height: 50px;

                span {
                    width: 25.5px;
                    height: 25px;
                    background-size: cover;
                }
                &.minus {
                    span {
                        background: url(/src/assets/images/icons/minus.svg)
                    }
                }
                &.plus {
                    span {
                        background: url(/src/assets/images/icons/plus.svg)
                    }
                }
                &.item-count
                    width: 45px;
                    height: 50px;
                    background: #FFFFFF;
                    border: 2px solid #E1E6EF;                    
                    letter-spacing: -0.02em;
                    color: #201747;
                    font-family: 'Manrope';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 33px;
                &.btn-update-count
                    background: #685BC7;     
                    padding: 10px 16px; 
                    width: 45px;
                    height: 50px;
                    divansition-duration: .4s;
                    cursor: pointer 
                    &:hover
                        background: #50469a;
    #content .product-data,
    .product-data {
        .product-img {
            width: 101.81px;
            height: 98px;
            background-size: cover;
            object-fit: cover;
            background-color: #e1e6ef;
            transition-duration: 2s;
            cursor: pointer;

            &:hover {
                transform: scale(1.4);
            }
            
           &-wrap {
                border-radius: 5px;
                width: 101.81px;
                height: 98px;
                overflow: hidden;
                position: relative;

                a {
                    position: absolute;
                    width: 101.81px;
                    height: 98px;
                }
           } 
        }

        .product-text {
            max-width: calc(100% - 102px);

            h2 {
                font-family: 'Manrope', sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 22px!important;
                line-height: 25px;
                color: #1D2433;

                @media screen and (max-width: 991px) {
                    font-size: 18px!important;
                }

                a:visited,
                a {
                    text-decoration: none;
                    transition-duration: .4s;
                    color: #1D2433;

                    &:hover {
                        color: #2ad2c9;
                    }
                }
            }

            .product-description {
                list-style: none;
                flex-wrap: wrap;             

                li {
                    padding-right: 5px;
                    margin-right: 5px;
                    border-right: 1px solid #1D2433;
                    font-family: 'Manrope';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 1.3;
                    white-space: nowrap; 
                    
                    @media screen and (max-width: 991px) {
                        font-size: 12px;
                        line-height:.8;
                    }

                    @media (max-width: 500px) {
                        margin-bottom: .5rem;
                    }

                    &:last-child {
                        border-right: none;
                        padding-right: 0;
                        margin-right: 0;
                    }
                }
            }
        }
    }
</style>